import { PiUserCircleFill } from 'react-icons/pi';
import { FaBell } from 'react-icons/fa';
import { FaBarsStaggered } from 'react-icons/fa6';
import { useState, useRef, useEffect } from 'react';
import { PiUserRectangle } from 'react-icons/pi';
import { ImExit } from 'react-icons/im';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { logout } from '../utils/logout';
import { MdPayments } from 'react-icons/md';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { MdHistory } from 'react-icons/md';
import { Tooltip } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LoginIcon from '@mui/icons-material/Login';
import LockResetIcon from '@mui/icons-material/LockReset';

const Header = ({ setIsSidebarOpen, className = '' }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [actionsOpen, setActionsOpen] = useState(false);
  const menuRef = useRef(null);
  const actionRef = useRef(null);
  const { userDetails, userPermissions } = useSelector(
    (state) => state.auth?.successData,
  );
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (actionRef.current && !actionRef.current.contains(event.target)) {
        setActionsOpen(false);
      }
    }
    if (actionsOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [actionsOpen]);

  return (
    <header className={`bg-[#EAEEFD] z-10 ${className} `}>
      <div className='flex justify-between items-center px-1  py-2'>
        <button
          className='bg-white rounded-sm p-2 hover:bg-gray-100 shadow-sm sm:hidden'
          onClick={() => setIsSidebarOpen((prev) => !prev)}
        >
          <FaBarsStaggered size={24} className='text-blue-600' />
        </button>{' '}
        <div className='flex items-center gap-3 ml-auto'>
          {/* Notifications Button */}
          <Tooltip title='Notifications'>
            <button
              className='relative bg-white rounded-full p-2 shadow hover:bg-gray-100 transition duration-300'
              onClick={() => {
                navigate('/settings', {
                  state: {
                    defaultValue:
                      userDetails?.role?.toLowerCase() === 'admin' ? 3 : 0,
                  },
                });
              }}
            >
              <span className='absolute top-1 right-1 flex size-2'>
                <span className='animate-ping absolute inline-flex size-full rounded-full opacity-75'></span>
                <span className='relative inline-flex rounded-full size-2'></span>
              </span>
              <FaBell />
              <span className='absolute top-0 right-0'>
                <span className='relative flex size-2'>
                  <span className='absolute inline-flex size-full animate-ping rounded-full bg-red-200 opacity-75'></span>
                  <span className='relative inline-flex size-2 rounded-full bg-red-500'></span>
                </span>
              </span>
            </button>
          </Tooltip>
          {/* Actions Menu */}
          <Tooltip title='Quick Access'>
            <div className='relative' ref={actionRef}>
              <div
                onClick={() => {
                  setActionsOpen((prev) => !prev);
                  setMenuOpen(false);
                }}
                className='grid place-content-center gap-[2px] grid-cols-3 *:size-[4.5px] *:bg-black *:rounded-full shadow-lg rounded-full p-[8.5px] bg-white hover:bg-gray-100 transition duration-300'
              >
                <div></div>
                <div></div>
                <div></div> <div></div>
                <div></div>
                <div></div> <div></div>
                <div></div>
                <div></div>
              </div>
              <div
                onClick={() => setActionsOpen(false)}
                className={` top-full  left-1/2 -translate-x-1/2   transition-all duration-500 absolute  mt-2 bg-white rounded-2xl shadow z-20 py-2
                  ${actionsOpen ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-95 pointer-events-none'} 
                  grid gap-2 grid-cols-2 w-max  p-3 border-2`}
              >
                {' '}
                <div className='col-span-2 my-2'></div>
                {/* payments */}
                {userPermissions?.payments && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() => {
                      navigate('/payments');
                    }}
                  >
                    {' '}
                    <MdPayments className='size-6 text-green-600' /> Payments
                  </div>
                )}
                {/* StudentInfo */}
                {userPermissions?.studentManagement && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() => navigate('/students/studentDetails')}
                  >
                    <AccountCircleIcon className='size-6 text-blue-600' />
                    Student Info
                  </div>
                )}
                {/* Add Student */}
                {userPermissions?.studentManagement && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() =>
                      navigate('/students', {
                        state: {
                          openStudentAdd: true,
                        },
                      })
                    }
                  >
                    <PersonAddIcon className='size-6 text-blue-600' />
                    Add Student
                  </div>
                )}
                {/* History */}
                {userPermissions?.history && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() =>
                      navigate('/history', { state: { defaultValue: 0 } })
                    }
                  >
                    <MdHistory className='size-6 text-red-600' />
                    History
                  </div>
                )}
                {/* New Login */}
                {userDetails?.role?.toLowerCase() === 'admin' && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() =>
                      navigate('/settings', { state: { defaultValue: 2 } })
                    }
                  >
                    <LoginIcon className='size-6 text-red-600' />
                    NewLogin
                  </div>
                )}
                {/* Change Password */}
                <div
                  className='flex flex-col items-center cursor-pointer'
                  onClick={() =>
                    navigate('/settings', {
                      state: {
                        defaultValue:
                          userDetails?.role?.toLowerCase() === 'admin' ? 4 : 1,
                      },
                    })
                  }
                >
                  <LockResetIcon className='size-6 text-blue-600' />
                  change Password
                </div>
                <div className='col-span-2 my-2'></div>
              </div>
            </div>
          </Tooltip>
          {/* Profile Menu */}
          <div className='relative ' ref={menuRef}>
            <button
              className='flex items-center px-3 py-1 bg-white shadow rounded-xl focus:outline-none  hover:bg-gray-100 transition duration-300'
              onClick={() => {
                setMenuOpen((open) => !open);
                setActionsOpen(false);
              }}
            >
              <div className='flex items-center justify-center bg-transparent size-8 mr-2 rounded'>
                <PiUserCircleFill size={28} className='text-blue-600' />
              </div>
              <div>
                <div className='text-sm font-semibold leading-none text-left'>
                  {userDetails?.userName}
                </div>
                <div className='text-xs text-gray-500'>
                  {userDetails?.designation}
                </div>
              </div>
            </button>

            <div
              className={`transition-all duration-500 absolute right-0 mt-2 w-40 bg-white rounded-2xl shadow-lg z-20 py-2 ${menuOpen ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-95 pointer-events-none'}`}
            >
              <button
                onClick={() => {
                  navigate('/settings', {
                    state: {
                      defaultValue:
                        userDetails?.role?.toLowerCase() === 'admin' ? 5 : 3,
                    },
                  });
                  setMenuOpen((open) => !open);
                }}
                className='w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center gap-2'
              >
                <PiUserRectangle size={20} className='text-blue-600' />{' '}
                MyProfile
              </button>
              <button
                onClick={async () => {
                  localStorage.setItem('userName', null);
                  await logout();
                  setMenuOpen((open) => !open);
                }}
                className='w-full text-left px-4 py-2 text-sm hover:bg-gray-100 text-red-600 flex items-center gap-2'
              >
                <ImExit size={20} className='text-red-600' /> Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
